import { ExternalLink } from "lucide-react";
import { Button } from "@component/button";
import { Badge } from "@component/badge";
import {
    Tooltip,
} from "@component/tooltip";
import { Job } from "@type/job";
import { getStatusBadgeClass } from "@util/string";
import { formatHumanReadable } from "@util/date";
import { useNavigate } from "react-router-dom";

interface LinkedJobCardProps {
    assessment_id: string;
    job: Job;
}

export default function LinkedJobCard(props: LinkedJobCardProps) {
    const navigate = useNavigate();
    return (
        <div className="border border-gray-200 rounded-lg overflow-hidden">
            {/* Job Header */}
            <div className="p-6 bg-white border-b border-gray-200">
                <div className="flex items-start justify-between">
                    <div className="flex-1">
                        <div className="flex items-center gap-3 mb-2">
                            <h3 className="text-base font-semibold text-gray-900">
                                {props.job.job_title}
                            </h3>
                            <Badge
                                className={`shadow-none border-0 cursor-default ${getStatusBadgeClass(props.job.job_status === "Published" ? "Active" : props.job.job_status === "Deleted" ? "Closed" : props.job.job_status)}`}
                                style={{
                                    paddingTop: "4px",
                                    paddingBottom: "4px",
                                    borderRadius: "1rem",
                                }}
                            >
                                {props.job.job_status === "Published" ? "Active" : props.job.job_status === "Deleted" ? "Closed" : props.job.job_status}
                            </Badge>
                        </div>
                        <div className="flex items-center gap-4 text-sm font-normal text-gray-600">
                            <span>Created {formatHumanReadable(props.job.created_at, true)}</span>
                        </div>
                    </div>

                    {/* Navigate Icon with Tooltip */}
                    <Tooltip content={<p>View Job</p>}>
                        <Button
                            variant="ghost"
                            size="sm"
                            className="h-8 w-8 p-0 text-gray-500"
                            onClick={() => window.open(`/jobs/edit/${props.job.id}`, '_blank')}
                        >
                            <ExternalLink className="h-4 w-4" />
                        </Button>
                    </Tooltip>
                </div>

                {/* CTA Buttons */}
                <div className="flex items-center gap-3 mt-4">
                    <Button
                        variant="default"
                        size="sm"
                        className="w-full flex items-center justify-center bg-blue-600 hover:bg-blue-700 font-medium"
                        onClick={() => navigate(`/assess/${props.assessment_id}/${props.job.id}/submissions`)}
                    >
                        View Submissions
                    </Button>
                </div>
            </div>
        </div>
    );
}
